<template>
  <section id="technologies-used">
    <h2 class="sm:text-4xl text-2xl font-medium title-font text-gray-900 mb-8">
      Technologies We Work With
    </h2>

    <div id="types" class="flex flex-col gap-8 bg-[#68CBE1]/30 p-8 rounded-xl">
      <div id="web">
        <h3 class="text-2xl font-semibold mb-2">Web</h3>
        <div class="flex flex-wrap gap-8">
          <div>
            <p>Front-End</p>
            <div class="flex flex-wrap gap-4">
              <Icon v-for="item in frontend" :name="item" class="w-10 h-10" />
            </div>
          </div>
          <div>
            <p>Back-End</p>
            <div class="flex flex-wrap gap-4">
              <Icon v-for="item in backend" :name="item" class="w-20 h-10" />
              <svg
                width="192"
                height="40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 192 40"
                class="bg-[#64f] p-1"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M52.7 25.24c-.31-.07-.56-.15-.8-.25-.16-.08-.3-.16-.42-.27a.32.32 0 01-.11-.28c.12-1.27-.01-2.4.1-3.65.51-5.12 3.73-3.5 6.62-4.33 1.65-.47 3.31-1.39 3.92-3.2.1-.3.01-.62-.2-.85a37.06 37.06 0 00-6.26-5.68A37.5 37.5 0 0028.93.37a.47.47 0 00-.34.72A14.02 14.02 0 0033 5.43c.32.2.19.63-.18.54a8.39 8.39 0 01-2.98-1.3.36.36 0 00-.34-.03l-1.69.68a.46.46 0 00-.12.78 14 14 0 0016.43 1.39c.32-.2.83.2.73.56-.17.57-.36 1.36-.56 2.43-1.3 6.53-5.02 6.03-9.63 4.38-9.2-3.34-14.43-.49-19.07-6.13-.33-.4-.9-.53-1.28-.2a4.36 4.36 0 00.44 6.97c.15.1.34.06.45-.07.29-.37.52-.6.82-.76.31-.16.47.3.2.53-.99.87-1.27 1.91-1.91 3.97-1.02 3.21-.59 6.5-5.32 7.36-2.5.13-2.46 1.83-3.37 4.36-1.06 3.06-2.44 4.4-5 7.08-.36.36-.39.95 0 1.28 1.02.87 2.08.92 3.15.48 2.66-1.12 4.71-4.56 6.64-6.79 2.15-2.48 7.31-1.42 11.21-3.85 2.1-1.29 3.37-2.94 2.97-5.4-.07-.4.39-.64.55-.27.31.7.52 1.44.6 2.2.03.21.2.36.41.35 4.22-.24 9.67 4.41 14.77 5.67.31.08.53-.28.36-.55a9.41 9.41 0 01-1.33-3.1c-.1-.39.48-.5.68-.14a9.42 9.42 0 007.56 4.84c1.24.1 2.6-.05 4.02-.48 1.7-.51 3.27-1.17 5.14-.81a5.3 5.3 0 013.5 2.15c1.13 1.66 3.53 2.1 4.81.36a.83.83 0 00.08-.82c-2.82-6.6-9.97-7.05-13.05-7.85z"
                  fill="#fff"
                ></path>
                <path
                  d="M91.63 10.79a1 1 0 01.9-.82l3.42-.3a.4.4 0 01.43.48L92.94 29.3a1 1 0 01-.98.82h-2.59c-.23 0-.4-.2-.37-.44.06-.35-.37-.6-.67-.39-1.13.8-2.39 1.2-3.75 1.2a6.1 6.1 0 01-4.7-2.04A7.06 7.06 0 0178 23.49c0-2.5.77-4.58 2.31-6.24a7.69 7.69 0 015.9-2.49c1.43 0 2.64.38 3.63 1.13.33.25.85.1.92-.31l.87-4.8zm-5.8 15.8a3.7 3.7 0 002.9-1.26 4.54 4.54 0 001.1-3.1c0-1.06-.3-1.92-.9-2.57a3.02 3.02 0 00-2.35-.99c-1.18 0-2.13.42-2.87 1.26a4.47 4.47 0 00-1.11 3.1c0 1.05.3 1.9.9 2.57a3 3 0 002.34.98zM101.43 12.73c-.7 0-1.3-.25-1.8-.73a2.4 2.4 0 01-.75-1.8c0-.88.33-1.64.98-2.26.64-.63 1.4-.94 2.3-.94.69 0 1.28.25 1.78.76.5.52.74 1.12.74 1.79 0 .88-.32 1.62-.96 2.24-.64.63-1.4.94-2.29.94zm-.48 16.58a1 1 0 01-.98.82h-2.59a1 1 0 01-.98-1.18l2.33-13a1 1 0 01.99-.82h2.6a1 1 0 01.98 1.18l-2.35 13zM117.14 15.2c.11.05.2.14.25.25.05.12.04.26-.01.38L116 18.8a.5.5 0 01-.22.24.55.55 0 01-.49 0c-.47-.23-1-.33-1.56-.32-1.23 0-2.17.5-2.84 1.5-.24.38-.5 1.27-.79 2.66l-1.12 6.41a1 1 0 01-.98.83h-2.6a1 1 0 01-1-1.18l2.34-13a1 1 0 01.99-.82h2.2c.42 0 .74.37.67.78-.06.35.4.57.67.34a5.44 5.44 0 015.86-1.05zM125.13 14.76c2.4 0 4.2.77 5.4 2.3a6.44 6.44 0 011.16 5.54c-.01.13-.04.26-.08.4-.1.4-.48.66-.9.66h-9.2c-.53 0-.98.4-.9.92.1.67.38 1.2.84 1.61.66.59 1.51.88 2.57.88 1.49 0 2.82-.52 4-1.56.08-.06.17-.1.26-.1.11 0 .22.05.3.14l1.43 1.7a.46.46 0 01-.03.6 9.23 9.23 0 01-6.62 2.65c-2.22 0-4-.7-5.38-2.11a6.64 6.64 0 01-1.84-5.36 8.27 8.27 0 014.25-6.97 9.12 9.12 0 014.74-1.3zm-3.55 4.96c-.37.57.11 1.23.78 1.23h4.2c.53 0 1-.43.87-.95a2.63 2.63 0 00-.47-.97c-.48-.67-1.24-1-2.25-.99-.91 0-1.7.26-2.35.78-.3.26-.56.57-.78.9zM140.43 30.5c-2.15 0-3.9-.68-5.26-2.04a7.02 7.02 0 01-2.05-5.23 8.25 8.25 0 013.5-6.81 9.21 9.21 0 015.35-1.66c2.59 0 4.57.86 5.96 2.58.08.1.1.23.07.36a.4.4 0 01-.14.2l-2.7 2.15a.4.4 0 01-.23.09.41.41 0 01-.33-.16 3.38 3.38 0 00-2.79-1.3c-1.13 0-2.07.34-2.81 1.03a4.29 4.29 0 00-1.3 3.26c0 1.1.32 1.96.95 2.62.61.66 1.44 1 2.47 1 1.07 0 2.03-.4 2.86-1.18a.4.4 0 01.57.02l1.9 2.12a.42.42 0 01-.02.58 8.45 8.45 0 01-6 2.37zM160.45 17.72a1 1 0 01-.99.82h-2.64a1 1 0 00-.99.83l-.92 5.12c-.25 1.38.2 2.07 1.38 2.07.49 0 .95-.15 1.4-.44a.35.35 0 01.38-.01c.07.04.12.11.14.2l.65 2.39a.67.67 0 01-.26.71 6.33 6.33 0 01-3.63 1.09c-1.62 0-2.89-.47-3.8-1.41-.92-.92-1.23-2.3-.91-4.15l.95-5.22a1 1 0 00-.98-1.18h-.19a1 1 0 01-.98-1.17l.24-1.41a1 1 0 01.99-.83h.93a1 1 0 00.98-.82l.53-2.95a1 1 0 01.9-.82l3.36-.3a.4.4 0 01.42.48l-.58 3.23a1 1 0 00.98 1.18h1.9a1 1 0 01.99 1.17l-.25 1.42zM171.14 23.98l1.43-8.03a1 1 0 01.99-.82h2.56a1 1 0 01.99 1.18l-2.33 13a1 1 0 01-.98.82h-2.54a.38.38 0 01-.38-.45c.06-.36-.38-.62-.68-.4a6.53 6.53 0 01-3.78 1.22c-1.8 0-3.16-.6-4.07-1.78-.92-1.18-1.21-2.75-.88-4.71l1.45-8.06a1 1 0 01.98-.82h2.61a1 1 0 01.99 1.18l-1.34 7.46c-.14.85-.04 1.53.3 2.04.34.5.88.75 1.61.75 1.03 0 1.83-.39 2.4-1.15.31-.33.53-.8.67-1.43zM183.7 30.53c-1.49 0-2.8-.26-3.96-.78a5.19 5.19 0 01-2.4-1.85.43.43 0 01-.06-.31c.02-.1.07-.2.15-.26l2.24-2.09c.07-.06.15-.1.24-.1.11 0 .22.07.3.16.32.44.84.83 1.54 1.17.77.38 1.54.57 2.31.57.61 0 1.08-.12 1.41-.35.34-.24.51-.56.51-.97 0-.24-.09-.47-.27-.67-.18-.22-.4-.39-.65-.52-.33-.15-.65-.29-.97-.4a10.5 10.5 0 01-3.05-1.46 3.4 3.4 0 01-1.49-2.96c0-1.46.6-2.66 1.79-3.58a7.44 7.44 0 014.7-1.4 9.2 9.2 0 013.52.66c.98.41 1.72.96 2.22 1.66.07.09.1.2.07.32-.01.1-.06.2-.14.27l-2.17 1.91a.42.42 0 01-.27.1.44.44 0 01-.32-.14 4.26 4.26 0 00-1.4-1 4.38 4.38 0 00-1.82-.4c-.52 0-.94.1-1.26.32a.94.94 0 00-.47.82c0 .21.1.4.28.54.24.2.5.35.78.47l.43.19a44.05 44.05 0 001.33.52 7.64 7.64 0 012.7 1.85c.58.67.87 1.52.87 2.53 0 1.59-.61 2.84-1.84 3.77a7.79 7.79 0 01-4.85 1.4z"
                  fill="#fff"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div id="cloud">
        <h3 class="text-2xl font-semibold mb-2">Clouds</h3>
        <div class="flex flex-wrap gap-4">
          <Icon v-for="item in cloud" :name="item" class="w-10 h-10" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 295.93 37.28"
            class="w-20 h-10"
          >
            <g id="图层_2" data-name="图层 2">
              <g id="图层_1-2" data-name="图层 1">
                <rect
                  fill="#ff6a00"
                  x="19.94"
                  y="16.3"
                  width="19.92"
                  height="4.49"
                ></rect>
                <path
                  fill="#ff6a00"
                  d="M49.84,0H36.66l3.18,4.5,9.61,3a4.15,4.15,0,0,1,2.9,4V25.84h0a4.17,4.17,0,0,1-2.9,4l-9.61,2.94-3.18,4.5H49.84a9.94,9.94,0,0,0,9.95-10V10A10,10,0,0,0,49.84,0Z"
                ></path>
                <path
                  fill="#ff6a00"
                  d="M10,0H23.14L20,4.5l-9.61,3a4.16,4.16,0,0,0-2.91,4V25.84h0a4.18,4.18,0,0,0,2.91,4L20,32.78l3.18,4.5H10a10,10,0,0,1-10-10V10A10,10,0,0,1,10,0Z"
                ></path>
                <path
                  fill="#ff6a00"
                  d="M221.19,26a5.91,5.91,0,0,1-11.81,0V11.78a5.91,5.91,0,0,1,11.81,0V12h4.52v-.17a10.43,10.43,0,0,0-20.85,0V26a10.42,10.42,0,0,0,20.84,0v-.19h-4.52Z"
                ></path>
                <path
                  fill="#ff6a00"
                  d="M244.67,10.69a8.92,8.92,0,0,0-9,8.45v8.73a9,9,0,0,0,17.91,0V19.13A8.9,8.9,0,0,0,244.67,10.69Zm4.43,16.67a4.43,4.43,0,1,1-8.86,0V19.65a4.43,4.43,0,1,1,8.86,0Z"
                ></path>
                <rect
                  fill="#ff6a00"
                  x="227.95"
                  y="1.48"
                  width="4.5"
                  height="34.28"
                ></rect>
                <rect
                  fill="#ff6a00"
                  x="103.81"
                  y="10.69"
                  width="4.5"
                  height="25.07"
                ></rect>
                <rect
                  fill="#ff6a00"
                  x="94.81"
                  y="1.48"
                  width="4.5"
                  height="34.28"
                ></rect>
                <path
                  fill="#ff6a00"
                  d="M83.45,1.48H77.9L68.8,35.71v0h4.49l2.42-9.1,10,0,2.41,9v0h4.49L83.45,1.5Zm1,20.72H76.89L80.67,8Z"
                ></path>
                <path
                  fill="#ff6a00"
                  d="M270.27,27.83a4.44,4.44,0,1,1-8.88,0V10.69h-4.51V28.57A7.76,7.76,0,0,0,266.94,36a6.21,6.21,0,0,0,1.24-.51,7.7,7.7,0,0,0,1.87-1.35l.2-.19v1.84h4.54V10.69h-4.52Z"
                ></path>
                <rect
                  fill="#ff6a00"
                  x="103.81"
                  y="1.48"
                  width="4.5"
                  height="4.51"
                ></rect>
                <path
                  fill="#ff6a00"
                  d="M122.93,10.66a7.72,7.72,0,0,0-5.42,2.22l-.19.19V1.48h-4.51V35.76h4.51V33.92l.19.19a7.76,7.76,0,0,0,13.18-5.54V18.42A7.77,7.77,0,0,0,122.93,10.66Zm3.31,8.58v8.51a4.45,4.45,0,1,1-8.9,0V19.24a4.45,4.45,0,1,1,8.9,0Z"
                ></path>
                <path
                  fill="#ff6a00"
                  d="M164.89,10.66a7.72,7.72,0,0,0-5.43,2.22l-.19.19V1.48h-4.5V35.76h4.5V33.92l.19.19a7.76,7.76,0,0,0,13.18-5.54V18.42A7.77,7.77,0,0,0,164.89,10.66Zm3.3,8.58v8.5a4.45,4.45,0,1,1-8.9,0v-8.5a4.45,4.45,0,1,1,8.9,0Z"
                ></path>
                <path
                  fill="#ff6a00"
                  d="M291.42,1.48V13.07l-.19-.19a7.75,7.75,0,0,0-13.18,5.54V28.6a7.76,7.76,0,0,0,13.18,5.51l.19-.19v1.84h4.51V1.48Zm0,17.76v8.5a4.45,4.45,0,1,1-8.9,0v-8.5a4.45,4.45,0,1,1,8.9,0Z"
                ></path>
                <path
                  fill="#ff6a00"
                  d="M151.53,19.17a7.51,7.51,0,0,0-.09-.88l0-.12a9.2,9.2,0,0,0-1.54-3.76,8.79,8.79,0,0,0-6.69-3.73l-.52,0A9,9,0,0,0,133.83,18v0h4.42v0a4.45,4.45,0,0,1,4.35-3.59A4.46,4.46,0,0,1,147,18.69v2.1h-6.39a7.75,7.75,0,0,0-2,15.25l.12,0,.43.1.54.08h.11a10.9,10.9,0,0,0,1.17.06,8.5,8.5,0,0,0,2.71-.39,7.61,7.61,0,0,0,3.07-1.85l.2-.19v1.84h4.5v-3h0Zm-10.06,5H147v3.17a5,5,0,0,1-4.09,4.92,4.47,4.47,0,0,1-1,.12,4.52,4.52,0,0,1-2.28-.64,4.79,4.79,0,0,1-.58-.37,4.5,4.5,0,0,1-.69-.69l-.05-.06a4,4,0,0,1,3.19-6.45Z"
                ></path>
                <path
                  fill="#ff6a00"
                  d="M193.54,19.19a7.51,7.51,0,0,0-.09-.88l0-.12a9.16,9.16,0,0,0-1.54-3.75,8.85,8.85,0,0,0-6.69-3.74h-.52A9,9,0,0,0,175.84,18v0h4.41v0a4.43,4.43,0,0,1,8.78.68v2.1h-6.4a7.75,7.75,0,0,0-1.95,15.25l.12,0,.43.1.54.08h.11a10.82,10.82,0,0,0,1.17.07,8.5,8.5,0,0,0,2.71-.39,7.84,7.84,0,0,0,3.07-1.85l.2-.19v1.84h4.5v-3h0Zm-10.06,5H189V27.4a5,5,0,0,1-4.09,4.92,4.47,4.47,0,0,1-1,.12,4.52,4.52,0,0,1-2.28-.64,3.82,3.82,0,0,1-.58-.37,4.57,4.57,0,0,1-.7-.69l0-.06a3.94,3.94,0,0,1-.83-2.42A4,4,0,0,1,183.48,24.23Z"
                ></path>
              </g>
            </g>
          </svg>
        </div>
      </div>

      <div id="database">
        <h3 class="text-2xl font-semibold">Database / Storage</h3>
        <div class="flex flex-wrap gap-4">
          <Icon v-for="item in database" :name="item" class="w-20 h-10" />
        </div>
      </div>

      <div id="devops">
        <h3 class="text-2xl font-semibold mb-2">DevOps</h3>
        <div class="flex flex-wrap gap-8">
          <div>
            <p>Containers</p>
            <div class="flex flex-wrap gap-4">
              <Icon v-for="item in container" :name="item" class="w-20 h-10" />
            </div>
          </div>

          <div>
            <p>CI/CD</p>
            <div class="flex flex-wrap gap-4">
              <Icon v-for="item in cicd" :name="item" class="w-10 h-10" />
            </div>
          </div>
        </div>
      </div>

      <div id="monitoring">
        <h3 class="text-2xl font-semibold">Monitoring</h3>
        <div class="flex flex-wrap gap-4">
          <Icon v-for="item in monitoring" :name="item" class="w-10 h-10" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 90 47"
            class="w-20 h-10"
          >
            <path
              fill="#8abc00"
              d="M90 12.2C90 5.5 83.9 0 80.9 0c-3 0-9.1 5.5-9.1 12.2 0 3.3 1 6.2 2.5 8.4 0.5 1.1 1.4 2.3 2.2 3.5 1 1.4 2 2.8 2.6 4.2 -0.5 0.2-0.9 0.6-1.1 1.1 0.5 0.1 1 0.2 1.6 0.3 1.5 0.2 2.9 0.1 3.7-0.2 -0.5 0.4-2 0.6-3.7 0.5 -0.6 0-1.2-0.1-1.7-0.2 0 0.1 0 0.2 0 0.3v2.5c0 1.1 0.9 1.4 2 1.4h2.8c1.1 0 2-0.3 2-1.4v-2.5c0-0.9-0.7-1.7-1.6-1.9 0.4-0.8 0.8-1.6 1.2-2.4l0.4-0.8 0.3-0.6c0.2-0.4 0.6-1.2 1-1.9h0C88.3 20.4 90 16.6 90 12.2zM84.3 24.2l-0.3 0.6 -0.4 0.8c-0.4 0.8-0.9 1.7-1.2 2.6h-1.2v-3.7h-0.6v3.7h-0.9c-0.1 0-0.1 0-0.2 0 -0.6-1.4-1.6-2.9-2.6-4.4 -0.3-0.4-0.5-0.7-0.8-1.1 1.4 1.1 3 1.8 4.8 1.8 1.4 0 2.7-0.4 3.9-1.2C84.6 23.5 84.5 23.8 84.3 24.2zM84.2 23.2c0 0 2.9-3.1 3.7-7.5 -1.1 1.3-2.9 2.2-5 2.2 -3.3 0-6-2.1-6-4.7 0-2.6 2.7-4.7 6-4.7 2.1 0 3.9 0.8 5 2.1 -1.7-7.2-9.6-9-9.6-9s0.5-0.6 1.6-0.9c0.9-0.3 1.3-0.2 1.9 0 0.7 0.2 7.6 4 7.6 11.4C89.3 19.3 84.2 23.2 84.2 23.2z"
            />
            <path
              class="st1"
              d="M5 32.6c1.3 0 3.5 0.4 3.5 1.9 0 0.8-0.5 1.4-1.2 1.4 -0.7 0-1-0.5-2.1-0.5 -1.5 0-2.2 1.1-2.2 2.5 0 1.4 0.7 2.5 2 2.5 1.3 0 1.9-0.5 2.3-0.5 0.7 0 1.2 0.7 1.2 1.3 0 1.5-2.3 2-3.5 2C2 43.1 0 40.8 0 37.9 0 34.9 2 32.6 5 32.6z"
            />
            <path
              class="st1"
              d="M9.1 34.3c0-0.8 0.6-1.5 1.5-1.5 0.8 0 1.3 0.5 1.5 0.9 0.5-0.6 1.2-1.1 2-1.1 0.8 0 1.5 0.6 1.5 1.5 0 1-0.8 1.3-1.8 1.6 -1.3 0.4-1.7 0.7-1.7 2.2v3.6c0 0.8-0.6 1.5-1.5 1.5 -0.9 0-1.5-0.7-1.5-1.5L9.1 34.3 9.1 34.3z"
            />
            <path
              class="st1"
              d="M25.3 41.4c0 0.8-0.6 1.5-1.5 1.5 -0.7 0-1.2-0.5-1.4-0.9 -0.7 0.8-1.4 1.1-2.5 1.1 -2.6 0-4.5-2.3-4.5-5.3 0-2.9 2-5.3 4.5-5.3 1.1 0 1.9 0.3 2.5 1.1 0.2-0.4 0.7-0.9 1.4-0.9 0.9 0 1.5 0.7 1.5 1.5V41.4zM18.3 37.9c0 1.4 0.7 2.5 2 2.5s2-1.1 2-2.5c0-1.3-0.7-2.5-2-2.5S18.3 36.5 18.3 37.9z"
            />
            <path
              class="st1"
              d="M30 35.6h-2.6c-0.9 0-1.5-0.4-1.5-1.3 0-0.9 0.6-1.3 1.5-1.3h5.7c0.6 0 0.8 0.1 1.1 0.4 0.2 0.2 0.3 0.4 0.3 0.7 0 0.3-0.1 0.5-0.4 0.8l-4 5.4h3.1c0.9 0 1.5 0.4 1.5 1.4 0 0.9-0.6 1.4-1.5 1.4h-5.9c-0.5 0-0.7-0.1-1-0.2 -0.4-0.2-0.4-0.6-0.4-0.8 0-0.2 0-0.5 0.5-1.1L30 35.6z"
            />
            <path
              class="st1"
              d="M37.7 41.9l-2.5-5.9c-0.3-0.8-0.6-1.5-0.6-1.8 0-0.9 0.7-1.4 1.4-1.4 0.7 0 1.2 0.4 1.5 1.1l1.7 4.5 1.6-4c0.4-0.9 0.8-1.6 1.6-1.6 0.9 0 1.5 0.6 1.5 1.5 0 0.4-0.2 0.9-0.4 1.3L39.3 45.6C39 46.4 38.7 47 37.7 47c-1 0-1.4-0.8-1.4-1.3 0-0.5 0.2-0.8 0.5-1.6L37.7 41.9z"
            />
            <path
              class="st1"
              d="M47.5 38.8c0 0.6 0.5 1.6 2.4 1.6 1.5 0 2.3-0.9 3-0.9 0.7 0 1.2 0.5 1.2 1.3 0 1.4-2.4 2.4-4.6 2.4 -3.2 0-5.1-2.3-5.1-5.3 0-2.8 2.1-5.3 5.1-5.3 2.9 0 4.8 2.4 4.8 5 0 1-0.5 1.3-1.4 1.3L47.5 38.8 47.5 38.8zM51.3 36.8c0-0.7-0.7-1.8-1.9-1.8s-1.9 1.1-1.9 1.8H51.3z"
            />
            <path
              class="st1"
              d="M64.7 41.9c0 3.7-2.4 5.1-5.3 5.1 -1.5 0-4.4-0.6-4.4-2.2 0-0.7 0.6-1.3 1.2-1.3 0.9 0 1.4 0.9 3.1 0.9 1.8 0 2.5-1 2.5-2.6H61.7c-0.6 0.9-1.7 1.1-2.7 1.1 -2.8 0-4.3-2.5-4.3-5.1 0-2.9 2-5.3 4.5-5.3 1.1 0 1.9 0.3 2.5 1.1 0.2-0.4 0.7-0.9 1.4-0.9 0.9 0 1.5 0.7 1.5 1.5C64.7 34.3 64.7 41.9 64.7 41.9zM59.7 35.4c-1.3 0-2 1.1-2 2.5 0 1.4 0.7 2.5 2 2.5 1.3 0 2-1.1 2-2.5C61.7 36.5 61 35.4 59.7 35.4z"
            />
            <path
              class="st1"
              d="M75.5 41.9c0 3.7-2.4 5.1-5.3 5.1 -1.5 0-4.4-0.6-4.4-2.2 0-0.7 0.6-1.3 1.2-1.3 0.9 0 1.4 0.9 3.1 0.9 1.8 0 2.5-1 2.5-2.6H72.5c-0.6 0.9-1.7 1.1-2.7 1.1 -2.8 0-4.3-2.5-4.3-5.1 0-2.9 2-5.3 4.5-5.3 1.1 0 1.9 0.3 2.5 1.1 0.2-0.4 0.7-0.9 1.4-0.9 0.9 0 1.5 0.7 1.5 1.5C75.5 34.3 75.5 41.9 75.5 41.9zM70.5 35.4c-1.3 0-2 1.1-2 2.5 0 1.4 0.7 2.5 2 2.5 1.3 0 2-1.1 2-2.5C72.5 36.5 71.8 35.4 70.5 35.4z"
            />
            <path
              fill="#8abc00"
              d="M85 11.9c-0.5 0-1-0.3-1.7-0.3 -1.2 0-1.8 0.7-1.8 1.5 0 0.7 0.6 1.4 1.8 1.4 0.5 0 1.3-0.3 1.6-0.3 0.5 0 0.9 0.3 0.9 0.6 0 0.7-1.8 1-2.6 1 -2.3 0-3.8-1.3-3.8-2.7 0-1.4 1.6-2.8 3.8-2.8 0.9 0 2.6 0.2 2.6 0.9C85.9 11.5 85.5 11.9 85 11.9z"
            />
            <path
              class="st1"
              d="M77.7 42.1h-0.3c-0.1 0-0.2-0.1-0.2-0.2 0-0.1 0.1-0.2 0.2-0.2h1c0.1 0 0.2 0.1 0.2 0.2 0 0.1 0 0.2-0.2 0.2h-0.3v1.4c0 0.1-0.1 0.2-0.2 0.2 -0.1 0-0.2-0.1-0.2-0.2V42.1z"
            />
            <path
              class="st1"
              d="M78.9 42c0-0.1 0.1-0.2 0.3-0.2 0.1 0 0.2 0.1 0.3 0.2l0.3 1.1h0l0.3-1.1c0-0.1 0.1-0.2 0.3-0.2 0.1 0 0.3 0.1 0.3 0.2l0.3 1.6c0 0 0 0 0 0.1 0 0.1-0.1 0.2-0.2 0.2 -0.1 0-0.2-0.1-0.2-0.2l-0.2-1.1h0l-0.3 1.2c0 0.1-0.1 0.2-0.2 0.2 -0.1 0-0.2-0.1-0.2-0.2l-0.3-1.2h0l-0.2 1.1c0 0.1-0.1 0.2-0.2 0.2 -0.1 0-0.2-0.1-0.2-0.2 0 0 0 0 0 0L78.9 42z"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-20 h-10"
            viewBox="0 0 170 36"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.2383 27.9341C3.69126 25.562 2.46479 22.5181 3.43669 19.7285C4.40821 16.939 5.71561 14.9683 7.94739 14.1706C9.1173 13.7524 12.638 12.1819 15.3781 14.6092C18.1183 17.0366 19.4932 20.066 19.5946 22.1723C19.8759 28.0046 12.1689 30.3967 10.8148 30.3967C8.98962 30.3967 6.26678 29.5109 5.2383 27.9341Z"
              fill="#FF704C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.888 2.66154C14.8363 1.19485 11.47 10.1843 13.0654 11.2927C13.4696 11.5738 18.1709 5.84655 15.888 2.66154Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.0926 11.2657C11.3417 12.5756 8.29435 8.20184 8.91976 7.39912C10.3529 5.5589 10.9457 10.4932 11.0926 11.2657Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M28.6592 27.1002H31.9273V9.29102H28.6592V27.1002Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M45.9173 14.9346V27.1H42.7749V26.1217C41.8195 26.9746 40.6629 27.3509 39.4812 27.3509C37.7971 27.3509 36.2886 26.5732 35.3335 25.3946C34.5537 24.4414 34.1016 23.1871 34.1016 21.381V14.9346H37.3697V21.5068C37.3697 22.6102 37.5956 23.1621 37.9727 23.5885C38.4759 24.14 39.1799 24.3411 39.8081 24.3411C41.1909 24.3411 42.1966 23.4129 42.6492 22.836V14.9346H45.9173Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M59.4252 24.6167C57.9921 26.5232 56.1818 27.351 53.8943 27.351C50.1229 27.351 47.3577 24.5418 47.3577 21.0299C47.3577 17.4934 50.1988 14.6838 53.919 14.6838C56.031 14.6838 57.9167 15.6622 59.0481 17.1171L56.735 19.149C56.0813 18.2961 55.1007 17.694 53.919 17.694C52.0338 17.694 50.6262 19.1737 50.6262 21.0299C50.6262 22.9364 52.0086 24.3412 53.9949 24.3412C55.327 24.3412 56.383 23.5384 56.9106 22.7357L59.4252 24.6167Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M149.818 19.4731C149.14 18.5696 148.059 17.968 146.801 17.968C144.891 17.968 143.659 19.5479 143.659 21.3043C143.659 23.2103 145.042 24.6151 146.877 24.6151C148.108 24.6151 149.189 24.0131 149.818 23.11V19.4731ZM153.078 25.9128C153.078 28.0952 152.701 29.3997 151.972 30.4278C150.866 31.9583 148.905 32.861 146.567 32.861C144.179 32.861 141.916 31.7577 140.709 30.3529L142.771 28.2207C143.424 28.9227 144.556 29.9762 146.567 29.9762C147.623 29.9762 148.503 29.6505 149.056 28.9983C149.559 28.4468 149.81 27.3741 149.81 26.5212C149.13 27.1887 147.774 27.6253 146.542 27.6253C144.732 27.6253 142.997 26.8222 141.916 25.5683C140.961 24.4642 140.382 22.9595 140.382 21.3043C140.382 17.7171 143.047 14.9578 146.366 14.9578C147.748 14.9578 148.98 15.4097 149.935 16.1869V15.209H153.078V25.9128Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M111.115 17.7015C110.889 17.6263 110.411 17.5761 109.934 17.5761C108.501 17.5761 107.37 18.6042 106.967 19.3317V26.9822H103.699V14.8172H106.841V16.0455C107.571 15.1429 108.903 14.5659 110.386 14.5659C110.864 14.5659 111.14 14.6161 111.492 14.6663L111.115 17.7015Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M120.962 19.081C120.283 18.1775 119.202 17.5759 117.945 17.5759C116.034 17.5759 114.802 19.1558 114.802 20.9122C114.802 22.8182 116.185 24.223 118.021 24.223C119.252 24.223 120.333 23.621 120.962 22.7179V19.081ZM124.223 26.982H121.08V26.0036C120.075 26.8565 118.918 27.2332 117.686 27.2332C115.876 27.2332 114.167 26.4301 113.086 25.1762C112.13 24.0721 111.527 22.5674 111.527 20.9122C111.527 17.325 114.192 14.5657 117.51 14.5657C118.893 14.5657 120.125 15.0176 121.08 15.7948V14.8169H124.223V26.982Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M126.897 26.9822V14.8172H130.039V15.7951C130.969 15.0425 132.126 14.5659 133.483 14.5659C135.168 14.5659 136.701 15.3185 137.707 16.5225C138.511 17.4758 138.964 18.7045 138.964 20.7866V26.9822H135.696V20.5358C135.696 19.3317 135.419 18.7045 134.967 18.253C134.539 17.827 133.886 17.5761 133.131 17.5761C131.749 17.5761 130.617 18.4541 130.164 19.0812V26.9822H126.897Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M163.587 19.4493C163.476 18.2518 162.387 17.0823 160.908 17.0823C159.401 17.0823 158.172 18.224 158.005 19.4493H163.587ZM166.355 25.0507C165.173 26.4554 163.238 27.2331 161.352 27.2331C157.706 27.2331 154.966 24.7246 154.966 20.912C154.966 17.5256 157.279 14.5659 160.899 14.5659C164.268 14.5659 166.657 17.4001 166.657 20.7866C166.657 21.1127 166.631 21.4388 166.581 21.7144H158.133C158.31 23.4201 159.693 24.5991 161.427 24.5991C162.81 24.5991 163.916 23.8215 164.494 23.1948L166.355 25.0507Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M95.0639 24.326C97.089 24.326 98.4746 22.7574 98.4746 20.8169C98.4746 18.8763 97.089 17.2807 95.0639 17.2807C93.0387 17.2807 91.6532 18.8763 91.6532 20.8169C91.6532 22.7574 93.0387 24.326 95.0639 24.326ZM95.0716 14.0906C98.9884 14.0906 101.947 17.0949 101.947 20.8169C101.947 24.5389 98.9884 27.5169 95.0716 27.5169C91.1545 27.5169 88.1968 24.5389 88.1968 20.8169C88.1968 17.0949 91.1545 14.0906 95.0716 14.0906Z"
              fill="#424A3C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M80.6268 14.9346L78.0379 20.9785L75.4487 14.9346H67.6863L63.8808 18.8729V9.29126H60.6123V27.1H63.8808V21.8326L68.6418 27.1H73.0413L66.7215 20.4027L71.9354 15.2799L76.2072 25.2516L73.504 31.5048H77.1705L84.2878 14.9346H80.6268Z"
              fill="#424A3C"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            style="isolation: isolate"
            viewBox="707.2 506.1 455.6 113.8"
            class="w-20 h-10"
          >
            <defs>
              <clipPath id="_clipPath_tOvNw7PV1qJ09W6brAGaclYADGLVjnVD">
                <rect x="707.2" y="506.1" width="455.6" height="113.8" />
              </clipPath>
            </defs>
            <g clip-path="url(#_clipPath_tOvNw7PV1qJ09W6brAGaclYADGLVjnVD)">
              <g>
                <g>
                  <path
                    d=" M 1103.28 619.9 L 1121.04 619.9 L 1121.04 585.34 L 1121.64 585.34 C 1123.44 592.18 1130.4 597.34 1138.56 597.34 C 1154.52 597.34 1162.8 585.7 1162.8 564.34 C 1162.8 542.98 1154.52 531.46 1138.56 531.46 C 1130.4 531.46 1123.44 536.5 1121.64 543.46 L 1121.04 543.46 L 1121.04 532.9 L 1103.28 532.9 L 1103.28 619.9 Z  M 1132.68 581.94 C 1125.96 581.94 1121.04 578.46 1121.04 572.7 L 1121.04 554.1 C 1121.04 548.34 1125.96 544.86 1132.68 544.86 C 1139.4 544.86 1144.32 550.02 1144.32 557.94 L 1144.32 568.86 C 1144.32 576.78 1139.4 581.94 1132.68 581.94 Z "
                    fill-rule="evenodd"
                    fill="rgb(233,64,86)"
                  />
                  <path
                    d=" M 763.6 595.9 L 778.96 595.9 L 778.96 549.22 L 745.96 549.22 L 745.96 564.46 L 761.56 564.46 L 761.56 568.66 C 761.56 576.82 754.24 581.14 745.12 581.14 C 733.84 581.14 726.52 574.66 726.52 560.74 L 726.52 547.3 C 726.52 533.38 733.84 526.9 745.12 526.9 C 754.84 526.9 760 532.18 762.52 538.66 L 777.4 530.14 C 771.16 517.3 760 510.7 745.12 510.7 C 722.44 510.7 707.2 526.18 707.2 554.38 C 707.2 582.46 722.32 597.34 741.52 597.34 C 754.12 597.34 761.8 590.98 763 582.58 L 763.6 582.58 L 763.6 595.9 Z "
                    fill="rgb(132,24,128)"
                  />
                  <path
                    d=" M 815.44 595.9 L 815.44 582.1 L 807.52 582.1 L 807.52 507.1 L 789.76 507.1 L 789.76 578.62 C 789.76 589.78 795.28 595.9 807.4 595.9 L 815.44 595.9 Z "
                    fill="rgb(132,24,128)"
                  />
                  <path
                    d=" M 825.12 595.9 L 842.88 595.9 L 842.88 532.9 L 825.12 532.9 L 825.12 595.9 Z "
                    fill="rgb(132,24,128)"
                  />
                  <path
                    d=" M 890.08 595.9 L 890.08 582.1 L 878.56 582.1 L 878.56 546.7 L 891.04 546.7 L 891.04 532.9 L 878.56 532.9 L 878.56 515.86 L 862.6 515.86 L 862.6 526.18 C 862.6 530.5 861.16 532.9 856.36 532.9 L 851.92 532.9 L 851.92 546.7 L 860.8 546.7 L 860.8 577.54 C 860.8 589.54 867.28 595.9 879.52 595.9 L 890.08 595.9 Z "
                    fill="rgb(132,24,128)"
                  />
                  <path
                    d=" M 924.36 596.34 C 936.72 596.34 945.72 590.94 949.92 578.94 L 936.12 572.94 C 934.32 577.98 931.44 582.3 924.36 582.3 C 917.16 582.3 913.44 577.26 913.44 569.34 L 913.44 557.58 C 913.44 549.66 917.16 544.5 924.36 544.5 C 930.6 544.5 934.08 548.34 935.16 553.14 L 949.56 546.9 C 945.84 536.58 937.08 530.46 924.36 530.46 C 905.4 530.46 894.96 543.18 894.96 563.34 C 894.96 583.5 905.4 596.34 924.36 596.34 Z "
                    fill="rgb(132,24,128)"
                  />
                  <path
                    d=" M 956.96 594.9 L 974.72 594.9 L 974.72 554.1 C 974.72 547.86 980.36 544.86 986.12 544.86 C 992.6 544.86 994.88 548.82 994.88 556.86 L 994.88 594.9 L 1012.64 594.9 L 1012.64 555.42 C 1012.64 539.58 1005.8 530.46 992.96 530.46 C 983 530.46 977.72 535.98 975.44 542.58 L 974.72 542.58 L 974.72 506.1 L 956.96 506.1 L 956.96 594.9 Z "
                    fill="rgb(132,24,128)"
                  />
                  <path
                    d=" M 834 526.86 C 841.2 526.86 844.32 523.14 844.32 518.1 L 844.32 515.46 C 844.32 510.42 841.2 506.7 834 506.7 C 826.8 506.7 823.68 510.42 823.68 515.46 L 823.68 518.1 C 823.68 523.14 826.8 526.86 834 526.86 Z "
                    fill="rgb(132,24,128)"
                  />
                  <path
                    d=" M 1062.59 508.777 L 1010.84 508.777 L 1010.84 524.977 L 1033.52 524.977 L 1033.52 594.9 L 1051.76 594.9 L 1051.76 524.977 L 1062.651 524.977 C 1062.079 523.211 1061.803 521.282 1061.803 519.236 L 1061.803 514.324 C 1061.803 512.353 1062.06 510.49 1062.59 508.777 Z "
                    fill="rgb(233,64,86)"
                  />
                  <path
                    d=" M 1081.003 526.86 C 1088.203 526.86 1091.323 523.14 1091.323 518.1 L 1091.323 515.46 C 1091.323 510.42 1088.203 506.7 1081.003 506.7 C 1073.803 506.7 1070.683 510.42 1070.683 515.46 L 1070.683 518.1 C 1070.683 523.14 1073.803 526.86 1081.003 526.86 Z "
                    fill="rgb(233,64,86)"
                  />
                  <path
                    d=" M 1072.123 595.9 L 1089.883 595.9 L 1089.883 532.9 L 1072.123 532.9 L 1072.123 595.9 Z "
                    fill="rgb(233,64,86)"
                  />
                </g>
                <g opacity="0.5">
                  <path
                    d=" M 729.52 547.971 L 729.52 547.3 C 729.52 533.38 736.84 526.9 748.12 526.9 C 757.84 526.9 763 532.18 765.52 538.66 L 780.4 530.14 C 774.16 517.3 763 510.7 748.12 510.7 C 726.838 510.7 712.107 524.33 710.372 549.311 L 710.372 549.311 L 729.52 547.971 Z  M 792.76 543.545 L 792.76 543.545 L 792.76 507.1 L 810.52 507.1 L 810.52 542.302 L 792.76 543.545 Z  M 828.12 541.07 L 828.12 541.07 L 828.12 532.9 L 845.88 532.9 L 845.88 539.827 L 828.12 541.07 Z  M 854.92 539.195 L 854.92 539.195 L 854.92 532.9 L 859.36 532.9 C 864.16 532.9 865.6 530.5 865.6 526.18 L 865.6 515.86 L 881.56 515.86 L 881.56 532.9 L 894.04 532.9 L 894.04 536.457 L 854.92 539.195 Z  M 910.023 535.338 L 910.023 535.338 C 914.591 532.173 920.402 530.46 927.36 530.46 C 932.383 530.46 936.789 531.414 940.51 533.205 L 910.023 535.338 Z  M 959.96 531.844 L 959.96 531.844 L 959.96 506.1 L 977.72 506.1 L 977.72 530.601 L 959.96 531.844 Z  M 837 526.86 C 844.2 526.86 847.32 523.14 847.32 518.1 L 847.32 515.46 C 847.32 510.42 844.2 506.7 837 506.7 C 829.8 506.7 826.68 510.42 826.68 515.46 L 826.68 518.1 C 826.68 523.14 829.8 526.86 837 526.86 L 837 526.86 Z "
                    fill-rule="evenodd"
                    fill="rgb(233,64,86)"
                  />
                </g>
                <g opacity="0.5">
                  <path
                    d=" M 781.96 580.293 L 781.96 565.793 L 764.56 567.012 L 764.56 568.66 C 764.56 576.82 757.24 581.14 748.12 581.14 C 739.509 581.14 733.206 577.364 730.705 569.384 L 712.197 570.681 C 713.682 576.197 715.945 580.884 718.82 584.717 L 781.96 580.293 Z  M 810.52 578.291 L 810.52 563.791 L 792.76 565.036 L 792.76 578.62 C 792.76 578.929 792.764 579.234 792.773 579.535 L 810.52 578.291 Z  M 845.88 575.814 L 845.88 561.314 L 828.12 562.558 L 828.12 577.058 L 845.88 575.814 Z  M 881.56 573.314 L 881.56 558.814 L 863.8 560.058 L 863.8 574.558 L 881.56 573.314 Z  M 916.488 570.866 C 916.456 570.37 916.44 569.861 916.44 569.34 L 916.44 557.58 C 916.44 557.168 916.45 556.764 916.47 556.367 L 898.258 557.643 C 898.06 559.468 897.96 561.368 897.96 563.34 C 897.96 566.445 898.208 569.376 898.696 572.113 L 916.488 570.866 Z  M 977.72 566.575 L 977.72 554.1 C 977.72 553.377 977.796 552.697 977.939 552.06 L 959.96 553.32 L 959.96 567.82 L 977.72 566.575 Z  M 997.209 550.71 C 997.674 552.393 997.88 554.442 997.88 556.86 L 997.88 565.163 L 1015.64 563.918 L 1015.64 555.42 C 1015.64 553.306 1015.518 551.312 1015.277 549.444 L 997.209 550.71 Z "
                    fill-rule="evenodd"
                    fill="rgb(233,64,86)"
                  />
                </g>
                <path
                  d=" M 778.96 565.766 L 778.96 549.22 L 745.96 549.22 L 745.96 564.46 L 761.56 564.46 L 761.56 566.985 L 778.96 565.766 Z  M 727.697 569.358 C 726.927 566.891 726.52 564.022 726.52 560.74 L 726.52 547.801 L 707.384 549.142 C 707.262 550.836 707.2 552.582 707.2 554.38 C 707.2 560.422 707.9 565.852 709.19 570.655 L 727.697 569.358 Z  M 807.52 563.765 L 807.52 542.125 L 789.76 543.369 L 789.76 565.009 L 807.52 563.765 Z  M 842.88 561.287 L 842.88 539.647 L 825.12 540.892 L 825.12 562.532 L 842.88 561.287 Z  M 878.56 558.787 L 878.56 546.7 L 891.04 546.7 L 891.04 536.272 L 851.92 539.014 L 851.92 546.7 L 860.8 546.7 L 860.8 560.031 L 878.56 558.787 Z  M 913.472 556.34 C 913.845 549.126 917.543 544.5 924.36 544.5 C 930.6 544.5 934.08 548.34 935.16 553.14 L 949.56 546.9 C 947.263 540.529 943.046 535.758 937.161 533.04 L 907.327 535.131 C 900.489 539.718 896.365 547.495 895.261 557.617 L 913.472 556.34 Z  M 974.945 552.033 C 976.048 547.196 981.037 544.86 986.12 544.86 C 990.641 544.86 993.118 546.788 994.202 550.683 L 1012.273 549.417 C 1010.698 537.298 1004.079 530.46 992.96 530.46 C 983 530.46 977.72 535.98 975.44 542.58 L 974.72 542.58 L 974.72 530.409 L 956.96 531.653 L 956.96 553.293 L 974.945 552.033 Z "
                  fill-rule="evenodd"
                  fill="rgb(233,64,86)"
                />
                <path
                  d=" M 778.96 580.459 L 778.96 595.9 L 763.6 595.9 L 763.6 595.9 L 763.6 595.9 L 763.6 595.9 L 763.6 595.9 L 763.6 595.9 L 763.6 582.58 L 763 582.58 C 761.8 590.98 754.12 597.34 741.52 597.34 C 731.271 597.34 722.184 593.1 715.94 584.875 L 778.96 580.459 Z  M 789.778 579.701 C 790.129 590.175 795.677 595.9 807.4 595.9 L 815.44 595.9 L 815.44 595.9 L 815.44 595.9 L 815.44 595.9 L 815.44 595.9 L 815.44 595.9 L 815.44 582.1 L 807.52 582.1 L 807.52 578.458 L 789.778 579.701 Z  M 825.12 577.225 L 825.12 595.9 L 825.12 595.9 L 825.12 595.9 L 825.12 595.9 L 825.12 595.9 L 842.88 595.9 L 842.88 575.98 L 825.12 577.225 Z  M 860.8 574.725 L 860.8 577.54 C 860.8 589.54 867.28 595.9 879.52 595.9 L 890.08 595.9 L 890.08 595.9 L 890.08 595.9 L 890.08 595.9 L 890.08 582.1 L 878.56 582.1 L 878.56 573.48 L 860.8 574.725 Z  M 895.725 572.277 C 898.45 587.217 908.378 596.34 924.36 596.34 L 924.36 596.34 L 924.36 596.34 C 936.72 596.34 945.72 590.94 949.92 578.94 L 936.12 572.94 C 934.32 577.98 931.44 582.3 924.36 582.3 C 917.687 582.3 914.003 577.971 913.5 571.032 L 895.725 572.277 Z  M 956.96 567.986 L 956.96 594.9 L 956.96 594.9 L 974.72 594.9 L 974.72 566.742 L 956.96 567.986 Z  M 994.88 565.329 L 994.88 594.9 L 1012.64 594.9 L 1012.64 564.085 L 994.88 565.329 Z "
                  fill-rule="evenodd"
                  fill="rgb(255,63,42)"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>

      <div id="seo">
        <h3 class="text-2xl font-semibold">SEO</h3>
        <div class="flex flex-wrap gap-4">
          <Icon v-for="item in seo" :name="item" class="w-10 h-10 my-auto" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-20 h-10 my-auto"
            viewBox="0 0 200 57"
            fill="none"
          >
            <path
              d="M3.41176 24.4592H23.0679V30.0497L15.6758 30.6253C3.73462 31.5278 0 34.7376 0 43.6989V45.5088C0 52.0895 4.54901 56.036 11.5364 56.036C17.0588 56.036 20.2296 54.7189 24.1281 50.6895H24.7786V54.9628H32.6575V15.7467H3.41176V24.4641V24.4592ZM23.0679 43.3721C20.6296 45.8405 16.9769 47.4844 13.9699 47.4844C10.722 47.4844 9.33897 46.2503 9.42089 43.538C9.50281 39.7573 10.881 38.85 17.1359 38.2743L23.0679 37.6987V43.3721Z"
              fill="#FF8800"
            />
            <path
              d="M188.047 31.5329L182.197 30.9573C178.949 30.6304 178.134 29.806 178.134 27.1766C178.134 24.2156 179.272 23.4741 183.821 23.4741C187.883 23.4741 189.02 24.1326 189.589 26.9279H198.687C198.441 17.5519 195.598 15.1713 184.307 15.1713C171.961 15.1713 168.872 17.5568 168.872 27.1766C168.872 35.977 171.147 38.3576 180.327 39.2649L185.122 39.7576C189.425 40.1674 190.485 40.9918 190.485 43.6212C190.485 46.8262 189.184 47.6506 183.907 47.6506C179.276 47.6506 178.057 46.9091 177.816 43.87H168.636C168.882 53.5728 171.802 56.0411 183.503 56.0411C196.499 56.0411 199.747 53.4069 199.747 42.7187C199.747 34.7428 197.39 32.4403 188.052 31.5378L188.047 31.5329Z"
              fill="#054ADA"
            />
            <path
              d="M139.309 32.2744C139.309 19.6105 135.005 15.1713 122.655 15.1713C110.304 15.1713 105.678 20.9276 105.678 35.2355C105.678 50.8605 109.904 56.0411 123.546 56.0411C133.377 56.0411 137.516 52.9971 138.899 44.4456H129.56C128.505 47.0798 127.368 47.6506 123.387 47.6506C117.378 47.6506 115.831 45.9237 115.508 38.6063H138.658C139.063 36.4697 139.309 33.9184 139.309 32.2744ZM115.59 30.8743C115.672 25.3668 117.865 23.3082 123.064 23.3082C128.264 23.3082 130.052 25.3619 130.211 30.8743H115.59Z"
              fill="#054ADA"
            />
            <path
              d="M64.6596 15.747H49.4705V3.98553H39.8039V54.9679H49.4705V24.5424H63.2766V54.9679H72.9432V23.7229H64.6596V15.747Z"
              fill="#054ADA"
            />
            <path
              d="M144.749 17.4695V54.9685H154.416V24.1332H166.029V15.7475H154.416V14.6792C154.498 12.3767 155.066 11.7181 156.931 11.7181H167.489V3.99098H156.117C148.402 3.99098 144.744 6.37644 144.744 17.4744L144.749 17.4695Z"
              fill="#054ADA"
            />
            <path
              d="M80.0944 54.9677H89.7562V24.9519H104.136V15.7467H80.0944V54.9677Z"
              fill="#054ADA"
            />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-16 h-16">
            <g>
              <g id="svg_9">
                <path
                  id="svg_1"
                  d="m31.49749,37.34605a1,1 0 1 1 -2,0l0,-25a1,1 0 0 1 2,0l0,25z"
                  fill="#182542"
                />
                <path
                  id="svg_2"
                  d="m14.49749,35.34605l31,0l0,8l-22,0c-6,0 -9,-8 -9,-8z"
                  fill="#182542"
                />
                <path
                  id="svg_4"
                  d="m16.49749,33.34605s2,-5 5,-9s8,-8 8,-8s-1,11 -1,16l0,1s-3,-1 -6,-1s-6,1 -6,1z"
                  fill="#182542"
                />
                <path
                  id="svg_5"
                  d="m31.49749,13.34605s6,6 9,11c2.771,4.618 4,9 4,9s-3,-1 -6,-1s-6,1 -6,1l0,-1c0,-9 -1,-19 -1,-19z"
                  fill="#182542"
                />
                <path
                  id="svg_6"
                  d="m13.49749,35.34605a1,1 0 1 0 0,2l33,0l0,-2l-33,0z"
                  fill="#182542"
                />
              </g>
              <path
                stroke="null"
                id="svg_14"
                d="m2.86163,29.99967l0,0c0,-14.98811 12.15027,-27.13838 27.13837,-27.13838l0,0c7.19754,0 14.1003,2.85921 19.18972,7.94865c5.08943,5.08943 7.94865,11.99218 7.94865,19.18973l0,0c0,14.98811 -12.15026,27.13838 -27.13837,27.13838l0,0c-14.9881,0 -27.13837,-12.15027 -27.13837,-27.13838zm4.0815,0.02262l0.01468,0.31448c0,3.74703 2.28655,10.98928 6.91639,15.9006c4.62985,4.91131 12.65876,7.39508 16.60679,7.32808c3.94803,-0.067 11.72299,-2.18855 16.50089,-6.70414c4.77791,-4.51558 6.55876,-11.42522 6.55876,-15.17225c0,-3.74703 -1.13746,-11.56088 -6.02574,-16.96395c-4.88828,-5.40306 -13.65041,-8.53235 -17.39743,-8.53235l-0.43812,-0.02332c-3.74702,0 -12.64755,3.56808 -17.12724,8.60892c-4.47969,5.04084 -5.60898,11.49691 -5.60898,15.24393z"
                fill="#182542"
              />
            </g>
          </svg>
          <svg
            aria-labelledby="moz-logo-title-header"
            role="img"
            width="85"
            height="25"
            class="my-auto"
          >
            <path
              fill="#4dbdeb"
              d="M71 16L82.99 3h-25.1c-.48.018-.866.4-.89.882v2.736C54.697 2.696 49.97 0 44.5 0 38.036 0 32.61 3.76 31 8.863V3h-4.38c-1.043.015-1.957.478-2.62 1.177l-8.498 9.325L7 4.177C6.34 3.477 5.427 3.015 4.383 3H0v19h5.117c.492-.024.863-.42.883-.91V12l9.5 10.5L25 12v9.09c.017.49.415.886.905.91H31v-6.863C32.61 20.24 38.036 24 44.5 24c7.732 0 14-5.373 14-12 0-1.038-.17-2.04-.46-3H69L57 22h25.104c.48-.018.872-.403.896-.884V16H71zm-26.452 1.96c-3.764 0-6.818-2.668-6.818-5.96 0-3.293 3.053-5.96 6.818-5.96 3.768 0 6.822 2.668 6.822 5.96s-3.053 5.96-6.822 5.96z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const frontend = [
  "logos:vue",
  "logos:nuxt-icon",
  "logos:html-5",
  "logos:css-3",
  "logos:javascript",
  "logos:typescript-icon",
  "logos:tailwindcss-icon",
];

const backend = ["logos:nodejs", "logos:supabase"];

const cloud = [
  "logos:aws",
  "logos:firebase",
  "logos:google-cloud-platform",
  "logos:serverless",
];

const database = [
  "logos:mysql",
  "logos:cloudinary",
  "logos:mongodb",
  "logos:firebase",
  "logos:postgresql",
  "logos:mariadb",
  "logos:aws-aurora",
  "logos:aws-s3",
  "cryptocurrency-color:storj",
];

const container = ["logos:docker", "logos:kubernetes"];

const cicd = [
  "logos:bitbucket",
  "logos:circleci",
  "logos:buddy",
  "logos:jenkins",
  "logos:github-actions",
  "logos:argo",
];

const monitoring = ["logos:bugsnag", "logos:sentry-icon"];

const seo = ["simple-icons:semrush", "logos:google-search-console"];
</script>
